<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 p-10 rounded-lg shadow-lg flex flex-col items-center">
      <div class="w-12 h-12 border-4 border-gray-300 dark:border-gray-500 border-t-blue-500 dark:border-t-blue-400 rounded-full animate-spin"></div>
      <p class="mt-4 text-gray-700 dark:text-gray-100 text-lg font-semibold">Saving...</p>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "SaveModal",
};
</script>